import React from "react";
import styled from "styled-components";
import { Timeline_Detail } from "./Timeline_Detail";
import {
    read_timeline_value_label
} from "../../utils/timeline/timeline_formatting";

const TimelineOffer = styled.div`
    display: grid;
    gap: 0.6rem;
`;

// Displays only the useful reference for a final offer event.
export const Timeline_Offer = (props) => {
    return (
        <TimelineOffer>
            <Timeline_Detail
                label={props.t("Reference")}
                value={read_timeline_value_label(props.event?.data?.ref || props.event?.to?.ofrId || props.event?.to?.ofrid || props.event?.to?.offerId || props.event?.data?.ofrId || props.event?.data?.ofrid || props.event?.data?.offerId, "")}
            />
        </TimelineOffer>
    );
};
